import { Tooltip, Typography } from '@mui/material';
import { Link, useParams } from 'react-router';
import { collapseString } from '../../../utils/collapseString';
import DoNotStripSpacesSpan from '../../common/DoNotStripSpacesSpan';
import TrainingSetRename from '../actions/TrainingSetRename';
import TrainingSetDescriptionEdit from '../actions/TrainingSetDescriptionEdit';
import useGetTrainingSet from '../../hooks/useGetTrainingSet';
import CertifiedBadge from '../../common/CertifiedBadge';

interface IProps {
  tsCharLimit: number;
  tsNameAsLink?: boolean;
}

const TrainingSetName = ({ tsCharLimit, tsNameAsLink }: IProps) => {
  const { dpid, id: tsId } = useParams<{ dpid: string; id: string }>();

  const { data: trainingSet, isError, isLoading } = useGetTrainingSet(tsId || '');

  if (!tsId || isLoading || isError || !trainingSet) {
    return null;
  }

  const trainingSetLabel = collapseString(trainingSet.label, tsCharLimit, tsCharLimit);

  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <div>
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <Tooltip title={trainingSet.tokenizer_version || ''} placement="top">
            <Typography
              style={{ fontWeight: 'bold', fontSize: '18px', color: 'black' }}
              data-cy={`lbl-training-set-name-${trainingSetLabel}`}
            >
              {tsNameAsLink ? (
                <Link to={`/data-pools/${dpid}/train/${tsId}/details`} style={{ color: 'black' }}>
                  <DoNotStripSpacesSpan
                    title={trainingSetLabel}
                    cypressId={`link-training-set-name-${trainingSetLabel}`}
                  />
                </Link>
              ) : (
                trainingSetLabel
              )}
            </Typography>
          </Tooltip>
          <CertifiedBadge
            certifiedAt={trainingSet.certified_at}
            certifiedBy={trainingSet.certified_by}
          />
          <TrainingSetRename trainingSet={trainingSet} />
        </div>
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <Tooltip title={trainingSet.description || 'No Description'} placement="top">
            <Typography fontSize="11px" style={{ cursor: 'help' }} data-cy="lbl-training-set-desc">
              {collapseString(
                trainingSet.description || 'No Description',
                tsCharLimit,
                tsCharLimit
              )}
            </Typography>
          </Tooltip>

          <TrainingSetDescriptionEdit
            trainingSetId={tsId}
            trainingSetDescription={trainingSet.description || ''}
            iconType="edit"
            tooltip="Edit Description"
          />
        </div>
      </div>
    </div>
  );
};
export default TrainingSetName;
